var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 108,
    viewBox: "0 0 95 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.2222 101.898C42.2222 103.486 42.7783 105.009 43.768 106.132C44.7578 107.254 46.1002 107.885 47.5 107.885C48.8998 107.885 50.2422 107.254 51.2319 106.132C52.2217 105.009 52.7778 103.486 52.7778 101.898V59.9872H89.7222C91.122 59.9872 92.4644 59.3564 93.4542 58.2336C94.444 57.1108 95 55.5879 95 54C95 52.4121 94.444 50.8892 93.4542 49.7664C92.4644 48.6435 91.122 48.0127 89.7222 48.0127H52.7778V6.102C52.7778 4.51408 52.2217 2.9912 51.2319 1.86837C50.2422 0.745544 48.8998 0.114746 47.5 0.114746C46.1002 0.114746 44.7578 0.745544 43.768 1.86837C42.7783 2.9912 42.2222 4.51408 42.2222 6.102V48.0127H5.27778C3.87802 48.0127 2.5356 48.6435 1.54583 49.7664C0.55605 50.8892 0 52.4121 0 54C0 55.5879 0.55605 57.1108 1.54583 58.2336C2.5356 59.3564 3.87802 59.9872 5.27778 59.9872H42.2222V101.898Z",
    fill: "#787878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/addicon.f7cb394dc347392a53988c4efa6252f4.svg";
export { ForwardRef as ReactComponent };